import { useEffect, useState } from "react";
import { debounce } from "lodash";

const mobileViewWidthThresholdInPixels = 800;
const mobileViewHeightThresholdInPixels = 700;

export const isDesktopScreen = (): boolean => {
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  return (
    (window.screen.width >= mobileViewWidthThresholdInPixels && isPortrait) ||
    (window.screen.height >= mobileViewHeightThresholdInPixels && !isPortrait)
  );
};

export const isMobileView = (): boolean => !isDesktopScreen();

export const useWindowWidth = (): "lg" | "md" | "sm" => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const listener = debounce(() => setWidth(window.innerWidth), 125);
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  });
  return width > 1200 ? "lg" : width < 700 ? "sm" : "md";
};

export const pdfWidthMapping: Record<"sm" | "md" | "lg", number> = {
  sm: 600,
  md: 900,
  lg: 1200,
};
